import i18n from "i18next";
import { initReactI18next } from 'react-i18next';
import de from "./i18/de";
import dk from "./i18/dk";
import en from "./i18/en";
import fi from "./i18/fi";
import fr from "./i18/fr";
import sv from "./i18/sv";
import { decryptData } from "./services/dashboard-service/encryptionService";
const availableLanguages = ['en', 'sv', 'fi', 'fr', 'dk', 'de'];
const setLang = () => {
    try {
        const lang = localStorage.getItem("CurrentLanguage");
        if (lang) {
            return JSON.parse(decryptData(lang))
        }
        else {
            return "en"
        }
    }
    catch (err) {
        return "en"
    }
}

const defualtLng = setLang()

i18n.use(initReactI18next).init({
    lng: defualtLng || "en",
    fallbackLng: 'en',
    resources: {
        en: { translation: en },
        sv: { translation: sv },
        fi: { translation: fi },
        fr: { translation: fr },
        dk: { translation: dk },
        de: { translation: de },
    },
    whileList: availableLanguages,
    interpolation: {
        escapeValue: false,
    }
})


export default i18n;